import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs';
import {FlatManagerService} from '../service/flat-manager.service';

@Injectable()
export class FlatsResolver implements Resolve<any> {
  constructor(private flatManagerService: FlatManagerService) {
  }

  resolve(route: ActivatedRouteSnapshot,
          state: RouterStateSnapshot): Observable<any> {

    return this.flatManagerService.getFlats();

  }
}
